import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import DesktopPhotoPrompt from '../../../components/desktop-photo-prompt';
import type { IdDocImageErrorType, IdDocImageUploadError } from '../../../types';
type DesktopRetryViewProps = {
  docName: string;
  errors: IdDocImageErrorType[] | undefined;
  hasBadConnectivity: boolean | undefined;
  allowPdf: boolean;
  onBack: () => void;
  onComplete: ComponentProps<typeof DesktopPhotoPrompt>['onUploadSuccess'];
  onUploadError: (errs: IdDocImageUploadError[]) => void;
};
const DesktopRetryView = t0 => {
  const $ = _c(12);
  const {
    docName,
    errors,
    hasBadConnectivity,
    allowPdf,
    onBack,
    onComplete,
    onUploadError
  } = t0;
  let t1;
  if ($[0] !== onBack) {
    t1 = <NavigationHeader leftButton={{
      variant: "back",
      onBack
    }} />;
    $[0] = onBack;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== allowPdf || $[3] !== docName || $[4] !== errors || $[5] !== hasBadConnectivity || $[6] !== onComplete || $[7] !== onUploadError) {
    t2 = <DesktopPhotoPrompt docName={docName} isRetry={true} errors={errors} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} onUploadSuccess={onComplete} onUploadError={onUploadError} />;
    $[2] = allowPdf;
    $[3] = docName;
    $[4] = errors;
    $[5] = hasBadConnectivity;
    $[6] = onComplete;
    $[7] = onUploadError;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default DesktopRetryView;